module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Welcome to your trial!</h3>    \r\n    <p>What they have access to....</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-trialist.html
// module id = 387
// module chunks = 1